import type { ReactElement, ReactChild, JSXElementConstructor } from 'react';
import type { MessageDescriptor } from 'react-intl';

import type { Appearance } from '@atlaskit/button/old-button/types';

export type LinkProps = {
	actionSubjectId: string;
	appearance?: Appearance;
	ariaLabel?: MessageDescriptor;
	href?: string;
	icon?: ReactChild;
	messageDescriptor: MessageDescriptor;
	onClick?(): void;
	target?: string;
};

export type ChangeEditionSectionMessageButtonsWrapperProps = {
	canShowUpgradeButton?: boolean;
	children(_: {
		showUpgradeTryNowButton: boolean;
		showLearnMore: boolean;
		learnMoreIsPrimaryCTA: boolean;
	}): ReactElement | null;
	isSiteAdmin: boolean;
	shouldShowLearnMore?: boolean;
};

export const ChangeEditionSectionMessageButtonsWrapper = ({
	canShowUpgradeButton,
	children,
	isSiteAdmin,
	shouldShowLearnMore = true,
}: ChangeEditionSectionMessageButtonsWrapperProps): ReactElement<
	any,
	string | JSXElementConstructor<any>
> | null => {
	let showUpgradeTryNowButton: boolean = false;
	let showLearnMore: boolean = true;
	let learnMoreIsPrimaryCTA: boolean = true;

	if (canShowUpgradeButton) {
		if (isSiteAdmin) {
			showUpgradeTryNowButton = true;
		}

		if (showUpgradeTryNowButton) {
			// NOTE: Don't show 'Learn More' CTA if it will appear in between the
			// Upgrade Edition button and a secondary feature link (like
			// "Remove this page's restrictions" button). In those cases, "Learn
			// More" CTA will be displayed at the end of the general text content,
			// outside of this component.
			showLearnMore = shouldShowLearnMore;
			learnMoreIsPrimaryCTA = false;
		}
	}

	return children({
		showUpgradeTryNowButton,
		showLearnMore,
		learnMoreIsPrimaryCTA,
	});
};
